import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { SubNavHorizontalSharedComponent } from './sub.nav.horizontal.component';

@NgModule({
    declarations: [
        SubNavHorizontalSharedComponent
    ],
    imports: [
        CommonModule,
        RouterModule.forChild([])
    ],
    exports: [
        SubNavHorizontalSharedComponent
    ]
})

export class SubNavHorizontalSharedModule {}
